export default {"src":"/_next/static/media/vpc.13beace1.svg","height":76,"width":76};